import React from "react";
import { Outlet } from "react-router-dom";

const ReviewerRoutes: React.FC = () => {
  // Route protection temporarily removed
  return <Outlet />;
};

export default ReviewerRoutes;